module.exports = __webpack_public_path__ + "assets/16c3b781d6412befc0d3bd68f12ba44a.png";